import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/** The Shop section's styles for this module's pages (the platform's counted scroll lock keeps the page scrolling after sheets close). */
export function ShopFixes() {
    return _jsx(_Fragment, { children: _jsx("style", { children: CSS }) });
}
/** A Shop page with the section's fixes (one place, so no page can miss them). */
export function withShop(Page) {
    const Shop = () => _jsxs(_Fragment, { children: [_jsx(ShopFixes, {}), _jsx(Page, {})] });
    return Shop;
}
const CSS = `
`;
